import React from 'react';
import { LinkItemCont } from './Link.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { StyledTooltip } from '@room-match/shared-ui-components';
import { GoLink } from 'react-icons/go';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTooltip } from 'pages/Opportunities/components/CustomTooltip/CustomTooltip';

interface Props {
  url: string;
}

const LinkItemLite: React.FC<Props> = ({ url }) => {
  const openLink = () => {
    window.open(url.includes('://') ? url : `https://${url}`, '_blank')?.focus();
  };
  return (
    <CustomTooltip title={url}>
      <LinkItemCont
        style={{
          width: '100%',
          padding: '10px 15px',
        }}
        onClick={openLink}
      >
        <img
          style={{ width: 20, height: 20 }}
          src={`
            https://www.google.com/s2/favicons?sz=64&domain_url=${url}`}
        />
        <CustomTypography
          style={{
            //single line text
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 300,
            width: '100%',
            fontSize: 14,
          }}
        >
          {url}
        </CustomTypography>
        <GoLink style={{ width: 25, fontSize: 22, color: COLORS.PRIMARY }} />
      </LinkItemCont>
    </CustomTooltip>
  );
};

export default LinkItemLite;
